var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHexagonLineCircleIcon = function SvgHexagonLineCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 128,
    r: 23,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 181,
    r: 23,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 75,
    r: 23,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 23,
    r: 23,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 233,
    r: 23,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 75,
    r: 23,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 181,
    r: 23,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 10,
    d: "M113.5 22.5v210M23 75l182 106M205 75 23 181"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 10,
    d: "m113.5 21.774 91.562 52.863v105.726L113.5 233.226l-91.562-52.863V74.637z"
  }))));
};
export default SvgHexagonLineCircleIcon;